<template>
  <el-form status-icon :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="120px"
    v-loading="loading" class="carpo-form demo-ruleForm gap-y-6">
    <el-form-item :label="$t('PERSONNEL_CODE')" prop="employee_id">
      <el-input :disabled="ruleForm.disabled" type="text" @input="ruleForm.employee_id = toEnglish(ruleForm.employee_id)"
        v-model="ruleForm.employee_id" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item :label="$t('WORKING_STATUS')" prop="status.id" class="mt-5 md:mt-0" v-loading="statusLoading">
      <el-select :disabled="ruleForm.disabled" :placeholder="$t('SELECT_PLACEHOLDER')" filterable
        v-model="ruleForm.status.id">
        <template slot="prefix">
          <StatusPrefix :status="ruleForm.status.id" :statusList="statusList" />
        </template>

        <el-option v-for="item in statusList" :key="item.id" :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id">
          <div class="flex items-center">
            <span :style="`background-color:${item.color.code}`" class="mx-2 w-2 h-2 rounded-full"></span>
            <span>
              {{ $i18n.locale == "fa" ? item.fa_title : item.en_title }}
            </span>
          </div>
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('CONTRACT_DATE')" prop="contract_date">
      <date-picker :disabled="ruleForm.disabled" color="#151515" class="el-input__inner" v-model="ruleForm.contract_date"
        view="year" format="jYYYY-jMM-jDD" clearable :locale="$i18n.locale" />
    </el-form-item>
    <el-form-item :label="$t('HOURLY_SALARY')" prop="hourly_salary">
      <el-input-number :disabled="ruleForm.disabled" v-model="ruleForm.hourly_salary" :min="0"
        :step="100000"></el-input-number>
    </el-form-item>

    <el-form-item :label="$t('TERM_OF_THE_CONTRACT')" prop="term_of_the_contract">
      <el-input-number :disabled="ruleForm.disabled" v-model="ruleForm.term_of_the_contract" :min="1"></el-input-number>
    </el-form-item>

    <Subtitle :title="$t('FURTHER_INFO')" class="col-span-full" />

    <el-form-item class="col-span-full" :label="$t('description')" prop="description">
      <el-input :disabled="ruleForm.disabled" type="textarea" v-model="ruleForm.description"></el-input>
    </el-form-item>

    <el-form-item class="flex justify-end col-span-full mt-4" v-if="!ruleForm.disabled">
      <slot> </slot>
      <el-popconfirm class="ml-4 mr-2" :confirm-button-text="$t('YES')" :cancel-button-text="$t('NO')" icon="el-icon-info"
        icon-color="red" :title="$t('DELETE_FORM')" @confirm="$emit('resetForm', true)">
        <el-button slot="reference" class="ml-2" type="warning" plain>
          {{ $t("RESET_FORM_BTN") }}
        </el-button>
      </el-popconfirm>
      <el-button type="success" @click="submitForm('ruleForm')">
        {{ $t($route.name) }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { driverStatus } from "@/api/drivers";
import StatusPrefix from "@/components/elements/statusPrefix";
export default {
  props: ["ruleForm", "loading"],
  data() {
    return {
      statusList: [
        {
          fa_title: "",
          color: {
            code: "",
          },
          en_title: "",
          id: 1,
        },
      ],
      statusLoading: true,
      rules: {

        employee_id: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("PERSONNEL_CODE"),
            }),
            trigger: "blur",
          },
        ],

        status: {
          id: [
            {
              required: true,
              message: this.$i18n.t("REQUIRED_FIELD", {
                type: this.$i18n.t("WORKING_STATUS"),
              }),
              trigger: "blur",
            },
          ]
        },
      },
    };
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$refs[form].clearValidate();
          this.$emit("next", form);
          this.$emit("ruleForm", this.ruleForm);
        } else {
          this.$notify.error({
            title: this.$i18n.t("FIXED_ERRORS", {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: "error_msg",
          });
          return false;
        }
      });
    },
  },
  mounted() {
    driverStatus.api().then((res) => {
      if (res) {
        this.statusList = res;
        this.statusLoading = false;
      }
    });
  },
  components: {
    StatusPrefix,
  },
};
</script>
